import script from "./PayinsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PayinsPage.vue?vue&type=script&setup=true&lang=js"

import "./PayinsPage.vue?vue&type=style&index=0&id=678e9039&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-678e9039"]])

export default __exports__